import { Box, Heading, Text, Image, Container, Button } from "@chakra-ui/react";

import React from 'react'
import { useNavigate } from "react-router-dom";

const ServicesPage = ({title ,description,image}) => {

  const navigate=useNavigate();

  return (
    
    <Box>
  {/* Hero Section */}
  <Box position="relative" w="100%" h={{ base: "180px", md: "350px", lg: "400px" }}>
    <Image
      src={image}
      alt={title}
      objectFit="cover" // contain ki jagah cover rakha so background fill ho jaye
      w="100%"
      h="100%"
    />

    {/* Overlay */}
    <Box
      position="absolute"
      top="0"
      left="0"
      w="100%"
      h="100%"
      bg="rgba(0,0,0,0.5)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={4} // mobile pe padding for text
      textAlign="center"
    >
      <Heading color="white" fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}>
        {title}
      </Heading>
    </Box>
  </Box>

  {/* Content Section */}
  <Container maxW="container.lg" py={10}>
    <Text fontSize={{ base: "sm", md: "md" }} color="gray.600">
      {description}
    </Text>
  </Container>

  {/* CTA Section */}
  <Box bg="gray.100" py={10} textAlign="center">
    <Heading size="md" mb={4}>
      {title}
    </Heading>
    <Text mb={4}>
      Contact us today for more details and free consultation.
    </Text>
    <Button
      onClick={() => navigate("/contact")}
      colorScheme="red"
      bg="#B67300"
      _hover={{ bg: "#945c00" }}
    >
      Contact Us
    </Button>
  </Box>
</Box>

  )
}

export default ServicesPage